import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { IUser } from '../../../../core/models/IUser';
import { UserService } from '../../../../core/services/user.service';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-edit-profile',
  imports: [ReactiveFormsModule],
  templateUrl: './edit-profile.html',
  styleUrl: './edit-profile.scss'
})
export class EditProfile {
  @Input() user!: IUser | null;
  @Output() saveProfile = new EventEmitter<IUser>();
  @Output() cancelEdit = new EventEmitter<void>();

  profileForm: FormGroup;
  apiUrl = environment.apiUrl;

  constructor(
    private fb: FormBuilder,
    private userService: UserService, 

  ) {
    this.profileForm = this.fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      phoneNumber: [''],
      address: this.fb.group({
        street: [''],
        number: [''],
        zipCode: [''],
        city: [''],
        country: ['']
      })
    });
  }

  ngOnChanges() {
    if (this.user) {
      this.profileForm.patchValue(this.user);
    }
  }

  onSubmit() {
    if (this.profileForm.valid) {
      this.saveProfile.emit(this.profileForm.value);
    }
  }

  onCancel() {
    this.cancelEdit.emit();
  }
  
  onAvatarSelected(event : any){
    const input = event.target as HTMLInputElement;
    if (input.files && input.files[0]) {
      const file = input.files[0];

      this.userService.uploadAvatar(file).subscribe(avatarUrl => {
        if (this.user) {
          this.user.avatar = avatarUrl;
        }
      });
    }
  }
}